export const NA_PERSONAL_LOAN_FORM = 'naPersonalLoan/form/';
export const PERSONAL_LOAN_LEAD = 'naPersonalLoan/lead';
export const NA_PERSONAL_LOAN_FORM_SET_VALUE = `${NA_PERSONAL_LOAN_FORM}setValue/`;
export const NA_PERSONAL_LOAN_FORM_SET_VALID = `${NA_PERSONAL_LOAN_FORM}setValid/`;

export const FORM_SUCCESS_TRANSITION_LEADS = `${PERSONAL_LOAN_LEAD}/transition/formSuccess`;
export const FORM_SUBMITTING_TRANSITION_LEADS = `${PERSONAL_LOAN_LEAD}/transition/formSubmitting`;
export const FORM_ERROR_TRANSITION_LEADS = `${PERSONAL_LOAN_LEAD}/transition/formError`;

export const FORM_VALID_PERSONAL_LOAN_FORM = `${NA_PERSONAL_LOAN_FORM}transition/formValid`;
export const FORM_INVALID_PERSONAL_LOAN_FORM = `${NA_PERSONAL_LOAN_FORM}transition/formInvalid`;

export const API_PENDING_TRANSITION_PERSONAL_LOAN_FORM = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PERSONAL_LOAN_FORM = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PERSONAL_LOAN_FORM = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}/apiTransition/failure`;
export const LEAD_SEND_ACTION = `${NA_PERSONAL_LOAN_FORM}submit`;

export const SET_SIDEDRAWER_OPEN = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}isSidedrawerOpen`;

export const SET_FIRST_NAME_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}firstName`;
export const SET_FIRST_NAME_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}firstName`;
export const SET_SURNAME_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}surname`;
export const SET_SURNAME_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}surname`;
export const SET_ID_NUMBER_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}idNumber`;
export const SET_ID_NUMBER_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}idNumber`;
export const SET_CELLPHONE_NUMBER_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}cellphoneNumber`;
export const SET_CELLPHONE_NUMBER_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}cellphoneNumber`;
export const SET_TOWN_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}town`;
export const SET_TOWN_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}town`;
export const SET_EMPLOYMENT_STATUS_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}employmentStatus`;
export const SET_EMPLOYMENT_STATUS_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}employmentStatus`;
export const SET_WAGE_FREQUENCY_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}wageFrequency`;
export const SET_WAGE_FREQUENCY_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}wageFrequency`;
export const SET_PAYSLIP_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}payslip`;
export const SET_PAYSLIP_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}payslip`;
export const SET_EMPLOYER_NAME_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}employerName`;
export const SET_EMPLOYER_NAME_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}employerName`;
export const SET_CREDIT_CHECK_CONSENT_VALUE = `${NA_PERSONAL_LOAN_FORM_SET_VALUE}creditCheckConsent`;
export const SET_CREDIT_CHECK_CONSENT_VALID = `${NA_PERSONAL_LOAN_FORM_SET_VALID}creditCheckConsent`;

export const RESET_FORM = `${NA_PERSONAL_LOAN_FORM}reset`;

export const transitionLeads = {
    success: () => ({ type: FORM_SUCCESS_TRANSITION_LEADS }),
    submitting: () => ({ type: FORM_SUBMITTING_TRANSITION_LEADS }),
    error: () => ({ type: FORM_ERROR_TRANSITION_LEADS }),
};

export const transitionPersonalLoanForm = {
    formValid: () => ({
        type: FORM_VALID_PERSONAL_LOAN_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_PERSONAL_LOAN_FORM,
    }),
};

export const apiTransitionPersonalLoanForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PERSONAL_LOAN_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PERSONAL_LOAN_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PERSONAL_LOAN_FORM,
    }),
};

export const setFirstNameValue = (value) => ({
    type: SET_FIRST_NAME_VALUE,
    value,
});

export const setFirstNameValid = (error) => ({
    type: SET_FIRST_NAME_VALID,
    error,
});

export const setSurnameValue = (value) => ({
    type: SET_SURNAME_VALUE,
    value,
});

export const setSurnameValid = (error) => ({
    type: SET_SURNAME_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: SET_ID_NUMBER_VALUE,
    value,
});

export const setIdNumberValid = (error) => ({
    type: SET_ID_NUMBER_VALID,
    error,
});

export const setCellphoneNumberValue = (value) => ({
    type: SET_CELLPHONE_NUMBER_VALUE,
    value,
});

export const setCellphoneNumberValid = (error) => ({
    type: SET_CELLPHONE_NUMBER_VALID,
    error,
});

export const setTownValue = (value) => ({
    type: SET_TOWN_VALUE,
    value,
});

export const setTownValid = (error) => ({
    type: SET_TOWN_VALID,
    error,
});

export const setEmploymentStatusValue = (value) => ({
    type: SET_EMPLOYMENT_STATUS_VALUE,
    value,
});

export const setEmploymentStatusValid = (error) => ({
    type: SET_EMPLOYMENT_STATUS_VALID,
    error,
});

export const setWageFrequencyValue = (value) => ({
    type: SET_WAGE_FREQUENCY_VALUE,
    value,
});

export const setWageFrequencyValid = (error) => ({
    type: SET_WAGE_FREQUENCY_VALID,
    error,
});

export const setPayslipValue = (value) => ({
    type: SET_PAYSLIP_VALUE,
    value,
});

export const setPayslipValid = (error) => ({
    type: SET_PAYSLIP_VALID,
    error,
});

export const setEmployerNameValue = (value) => ({
    type: SET_EMPLOYER_NAME_VALUE,
    value,
});

export const setEmployerNameValid = (error) => ({
    type: SET_EMPLOYER_NAME_VALID,
    error,
});

export const setCreditCheckConsentValue = (value) => ({
    type: SET_CREDIT_CHECK_CONSENT_VALUE,
    value,
});

export const setCreditCheckConsentValid = (error) => ({
    type: SET_CREDIT_CHECK_CONSENT_VALID,
    error,
});

export const setSidedrawerIsOpen = (value) => ({
    type: SET_SIDEDRAWER_OPEN,
    value,
});

export const sendLead = () => ({ type: LEAD_SEND_ACTION });

export const resetForm = () => ({ type: RESET_FORM });
